module.exports = __webpack_public_path__ + "static/media/ic_notes.3a796b28.png";